import i18next from '../../../react/features/base/i18n/i18next';
import { setConferenceLang } from '../conference/actions';
export function setXbeesLangInConference(systemLanguage, store) {
    const { dispatch, getState } = store;
    // @ts-ignore
    const { systemLanguage: systemLanguageState } = getState()['xbees/base/conference'];
    if (systemLanguage && systemLanguage !== systemLanguageState) {
        if (i18next.isInitialized) {
            dispatch(setConferenceLang(systemLanguage));
        }
        else {
            i18next.on('initialized', () => {
                dispatch(setConferenceLang(systemLanguage));
            });
        }
    }
}
export function isXbees(state) {
    // @ts-ignore
    return state['features/base/config']?.isXbees;
}
